import { MatchStatus } from "./../../service";
import { MESSAGES } from "./constants";
import { LANGUAGE } from "_constants";

export type BaseballTabKey = "narration" | "stats";

export const BASEBALL_TABS: { key: BaseballTabKey; label: string }[] = [
  { key: "narration", label: "Narration" },
  { key: "stats", label: "Statistics" },
];

export const getBaseballTabIndex = (key: BaseballTabKey): number =>
  BASEBALL_TABS.findIndex((t) => t.key === key);

export const getBaseballTabKeyByIndex = (i: number): BaseballTabKey =>
  BASEBALL_TABS[i]?.key ?? "narration";

export const checkIsAway = (status: MatchStatus) => {
  if (!status.sc || status.sc.length === 4) return undefined;
  if (status.sc.length === 5) {
    if (status.sc.startsWith("2")) return true;
    else if (status.sc.startsWith("1")) return false;
    else if (status.sc.startsWith("0")) return undefined;
  }
};

export const getActiveTeamName = (status: MatchStatus) => {
  const isAway = checkIsAway(status);

  const homeName =
    (status as any)?.T1?.n ??
    (status as any)?.t1?.n ??
    (status as any)?.T1n ??
    null;
  const awayName =
    (status as any)?.T2?.n ??
    (status as any)?.t2?.n ??
    (status as any)?.T2n ??
    null;

  if (isAway === undefined) return null;
  return isAway ? awayName : homeName;
};

export const processStatus = (status: MatchStatus, language: LANGUAGE) => {
  const isAway = checkIsAway(status);
  const teamName = getActiveTeamName(status);

  const normalizedStatusCode = status.sc?.substr(status?.sc?.length - 4, 4) as
    | string
    | undefined;

  const messageDict = MESSAGES[language];
  const message = normalizedStatusCode
    ? messageDict?.[normalizedStatusCode]?.toUpperCase?.()
    : undefined;

  return {
    isAway,
    teamName,
    normalizedStatusCode,
    message,
  };
};
